<template>
  <div class="i-tree">
    <!--suppress JSUnresolvedVariable -->
    <el-tree ref="siteDeviceTree" :default-expand-all="showPopBox"
             :data="tree"
             node-key="code"
             :default-checked-keys="defaultcheckedkey"
             :expand-on-click-node="false"
             :render-content="showPopBox ? renderContent : undefined"
             :show-checkbox="showCheckBox"
             @check-change="changeCheckNode"
             :filter-node-method="filterNode"
             :load="loadNode"
             @node-click="handleNodeClick"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {nError, nSuccessFunc, nWarn} from '../../utils/notice'
import {pattern} from '../../utils/regular'
import {createAnErrorWithTip, errorHandler} from '../../utils/errorHandler'

export default {
  name: 'site-device-tree',
  props: {
    filterKey: {
      type: String,
      default: ''
    },
    showCheckBox: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '标题'
    },
    keyName: {
      type: String,
      default: '键名'
    },
    showPopBox: {
      type: Boolean,
      default: true
    },
    defaultcheckedkey: Array,
    maxDepth: {
      type: Number,
      default: 4
    },
    canChoose: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default () {
        return {
          1: [],
          2: ['add'],
          3: ['add', 'patch', 'delete'],
          4: ['patch', 'delete']
        }
      }
    },
    update: {
      type: Object,
      default () {
        return {
          render: () => [],
          addNode: this._print,
          removeNode: this._print,
          editNode: this._print
        }
      }
    }
  },
  watch: {
    'filterKey' (val) {
      this.$refs.tree.filter(val)
    }
  },
  data () {
    return {
      tree: [],
      treeFromServer: [],
      detailForm: {
        title: '添加营业单位',
        show: false,
        then: () => {
        },
        type: ''
      },
      roomNamelist: [],
      roomCodelist: [],
      roomAreaList: []
    }
  },
  created () {
    this.render()
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data._label.indexOf(value) !== -1
    },
    render () {
      this.update.render()
        .then(this.convertData)
    },

    convertData (treeFromServer) {
      // this.$refs.tree.setCheckedKeys(this.defaultcheckedkey);
      // console.log(this.$refs)
      const packNode = (nodes) => {
        const getNodes = nodeId =>
          treeFromServer.filter(n => n.parentCode === nodeId)

        nodes.forEach(node => {
          const children = getNodes(node.code)
          node.children = children
          if (children.length > 0) {
            packNode(children)
          }
        })
      }
      /**
       * 格式化原始数据
       */
      treeFromServer
        .forEach(it => {
          it.edidable = false
          it.label = it._label
        })

      /**
       * 生成顶层节点
       */
      const tree = treeFromServer.filter(tree => tree.parentCode == 0)

      /**
       * 开始组装节点
       */
      packNode(tree)

      this.tree = tree
    },
    getTargetDomNode (domNode) {
      const c = domNode.parentNode.parentNode.parentNode.getElementsByClassName('left')
      if (c.length === 1) {
        return c[0]
      }
    },
    getTargetChildDomNode (domNode) {
      return this.getTargetDomNode(domNode)
        .parentNode.parentNode.parentNode.getElementsByClassName('left')
    },
    onEnter (domNode) {
      return e => {
        const isEnter = e.inputType === 'insertParagraph'
        const isBackward = e.inputType === 'deleteContentBackward'
        const isForward = e.inputType === 'deleteContentForward'
        if (isEnter ||
          (!isBackward && !isForward && e.data === null)
        ) {
          e.target.innerHTML = e.target.innerText.trim()
          domNode.blur()
        }
      }
    },


    renderContent (h, {node, data}) {
      return (
        <span class="item">
          <span class="left">{data._label}</span>
        </span>
      )
    },
    handleNodeClick ($event) {
      // if (!this.canChoose && $event.level !== '6') {
      //   nError('该节点不能选择')
      //   return false
      // }
      // // const currentId = $event.id
      // // const isChecked = this.$refs.tree.getCheckedKeys().includes(currentId)
      // // const checkedKeys = isChecked ? [] : [currentId]
      // // this.$refs.tree.setCheckedKeys(checkedKeys)
      // this.$emit('selected', $event)
    },
    loadNode (node, resolve) {
    },
    changeCheckNode (data, nodeCheck, nodeChild) {
      let cat = this.$refs.siteDeviceTree.getCheckedNodes()
      this.roomNamelist = []
      this.roomCodelist = []
      this.roomAreaList = []
      cat.map(v => {
        if (v.type === '2') {
          if (this.roomNamelist.indexOf(v.label) === -1 && this.roomCodelist.indexOf(v.code) === -1) {
            this.roomNamelist.push(v._label)
            this.roomCodelist.push(v.code)
            this.roomAreaList.push(v.roomArea)
          }
        }
      })
      this.$emit('onChecked', this.roomNamelist.join(','), this.roomCodelist.join(','), this.roomAreaList.join(','))
    }
  }
}
</script>

<style scoped>
  .el-tree{
    height: 260px!important;
    overflow-y: auto;
  }
</style>

<style lang="less">
  .-the-tree .el-tree-node > .el-tree-node__children {
    overflow: visible!important;
  }

  .-the-tree {
    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .left {
      display: block;
      min-width: 50px;
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
      &:hover {
        text-overflow: unset;
        max-width: unset;
      }
    }
    .icon-more {
      display: block;
      font-size: 12px;
      color: #999999;
      position: relative;
      padding: 4px;
      overflow: visible;
      margin-right: 60px;
      .pop-box {
        display: none;
        background-color: #fff;
        width: 48px;
        position: absolute;
        top: 10px;
        left: 20px;
        user-select: none;
        z-index: 2018;
      }
      .operate {
        display: none;
        font-size: 12px;
        color: #999999;
        padding: 5px;
        margin-top: -1px;
        border: 1px solid #999999;
      }
      .operate:hover {
        color: #1362FF;
        border: 1px solid #1362FF;
      }
      &.show .pop-box {
        display: block !important;
        .operate {
          display: block !important;
        }
      }
    }
  }
</style>

<style lang="less">
  label {
    margin-bottom: 0 !important;
  }
  .i-tree {
    .el-tree-node {
      .el-tree-node__children {
        overflow: hidden!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/site-device-tree.vue